import { useEffect, useState } from "react";
import { Bell, CheckCheck } from "lucide-react";
import { API } from "../../lib/api";
import { fmtDate } from "../../lib/format";
import { PageHeader, Loading, Empty, StatusBadge } from "../../components/common";

const TYPE_TONE = { payment_failed: "FAILED", vault_shortfall: "SHORTFALL", return_ready: "READY_TO_FILE",
  payment_completed: "PAID", subscription_active: "ACTIVE" };

export default function Notifications() {
  const [data, setData] = useState(null);
  const load = () => API.get("/notifications").then((r) => setData(r.data));
  useEffect(() => { load(); }, []);

  const markAll = async () => { await API.post("/notifications/read-all"); load(); };
  const mark = async (id) => { await API.post(`/notifications/${id}/read`); load(); };

  if (!data) return <Loading label="Loading notifications" />;

  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" sub={`${data.unread} unread`}
        right={<button className="btn-outline-gov" onClick={markAll} data-testid="mark-all-read"><CheckCheck className="h-4 w-4" /> Mark all read</button>} />
      {data.notifications.length === 0 ? (
        <Empty title="No notifications" msg="Filing reminders, payment alerts, and vault warnings will appear here." />
      ) : (
        <div className="space-y-2">
          {data.notifications.map((n) => (
            <button key={n.id} onClick={() => mark(n.id)} data-testid={`notification-${n.id}`}
              className={`card-gov flex w-full items-start gap-3 px-4 py-3 text-left ${n.read ? "opacity-60" : "border-l-4 border-l-navy"}`}>
              <Bell className={`mt-0.5 h-4 w-4 shrink-0 ${n.read ? "text-slate-300" : "text-navy"}`} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-slate-800">{n.title}</span>
                  {TYPE_TONE[n.type] && <StatusBadge status={TYPE_TONE[n.type]} />}
                </div>
                <div className="mt-0.5 text-sm text-slate-500">{n.body}</div>
                <div className="mt-1 text-xs text-slate-400">{fmtDate(n.created_at)}</div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
